import { render, staticRenderFns } from "./AnswerBadges.vue?vue&type=template&id=8b1c1f0c&scoped=true&"
import script from "./AnswerBadges.vue?vue&type=script&lang=js&"
export * from "./AnswerBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c1f0c",
  null
  
)

export default component.exports